export default "__VITE_ASSET__GXTbkJCR__"